// Centralized data-testid registry.
export const IDS = {
  // Login
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  // Layout
  themeToggle: "theme-toggle",
  logoutBtn: "logout-btn",
  offlineBanner: "offline-banner",
  syncButton: "sync-button",
  navDashboard: "nav-dashboard",
  navScan: "nav-scan",
  navItems: "nav-items",
  navReorder: "nav-reorder",
  navSessions: "nav-sessions",
  navMeal: "nav-meal",
  navAdmin: "nav-admin",
  // Dashboard
  summaryItems: "summary-items",
  summaryBelowPar: "summary-below-par",
  summaryReorderCost: "summary-reorder-cost",
  summarySession: "summary-active-session",
  startSessionBtn: "start-session-btn",
  scanFab: "scan-fab",
  // Scan
  scanStartCamera: "scan-start-camera",
  scanStopCamera: "scan-stop-camera",
  scanManualInput: "scan-manual-input",
  scanManualSubmit: "scan-manual-submit",
  // Item detail
  itemDetailName: "item-detail-name",
  itemDetailQr: "item-detail-qr",
  qtyOriginal: "qty-original",
  qtyUnit: "qty-unit",
  qtyMixedUnits: "qty-mixed-units",
  qtyMixedPacks: "qty-mixed-packs",
  qtyMixedCases: "qty-mixed-cases",
  saveEntry: "save-entry",
  // Sessions
  sessionName: "session-name-input",
  createSession: "create-session-submit",
  submitSession: "submit-session",
  approveSession: "approve-session",
  rejectSession: "reject-session",
  reopenSession: "reopen-session",
  exportSession: "export-session",
  // Reorder
  exportReorder: "export-reorder",
  // Meal calc
  mealDietSelect: "meal-diet-select",
  mealTotalInput: "meal-total-input",
  mealCalcSubmit: "meal-calc-submit",
  mealCalcResult: "meal-calc-result",
  // Admin
  importFile: "import-file",
  importKind: "import-kind",
  importPreview: "import-preview",
  importCommit: "import-commit",
  qrPrintSelect: "qr-print-select",
  qrPrintDownload: "qr-print-download",
  qrGenerateMissing: "qr-generate-missing",
  // Notifications
  navNotifications: "nav-notifications",
  notifBell: "notif-bell",
  notifBellBadge: "notif-bell-badge",
};

export default IDS;
